export enum EVirtualizedTableCellType {
    CHECKBOX, // Checkbox
    TEXTINPUT, // TextInput
    NUMBERINPUT, // NumberInput
    WORKFLOWSTATE, // WorkFlowInput
    TEXTAREA, // TextArea
    DROPDOWN, // DropDown
    TWOLANGUAGEINPUT, // two language short input
    TWOLANGUAGETEXTAREA, // two language long input
    TWOLANGUAGECOMPAREINPUT, // two language short input with text compare component
    TWOLANGUAGECOMPARETEXTAREA, // two language long input with text compare component
    DATE, // react-datepicker
    PRICE, // react-number-format
    DERIVATE, // special cell renderer and filter renderer for the derivate view
    DEFAULTINPUT, // Input field for both text and number(carefull with zero as number vs 0 as empty string)
    ONCLICKINPUT, // special input field for data that has to be edited in a different dialog
    COLORDROPDOWN, // dropdown for modeltype colors
    REFERENCE,// Option basic reference cell
    OPTION_INDICATOR,// Option indicator cell
    FLAG, // Flags cell
    GENERATION // Generation cell
}

export enum EVirtualizedTableFilterType {
    STRING,
    BOOLEAN
}

export enum PDiPFilterEnum {
    SHOW_ALL = "",
    SHOW_PDIP_VALID = "true",
    SHOW_PDIP_INVALID = "false"
}

export enum PCCDFilterEnum {
    SHOW_ALL = "",
    SHOW_PCCD_VALID = "true",
    SHOW_PCCD_INVALID = "false"
}


// WEBPACK FOOTER //
// ./src/components/Table/VirtualizedTableEnums.ts